import { contextKey, i18n } from '@/i18n'

/**
 * Фраза из shared.po, msgctxt "history" (msgid — стабильный ключ).
 *
 * @param {string} msgid ключ в shared.po
 * @param {object} [params] плейсхолдеры vue-i18n
 * @returns {string}
 */
export function historyPo(msgid, params) {
  return i18n.global.t(contextKey('history', msgid), params ?? {})
}

export function historyPhrase(key, params) {
  return i18n.global.t(`history.${key}`, params ?? {})
}

export function historyAction(key, params) {
  // shared.po: dossier_* и changed/added/deleted.
  // TODO(TRANSLATE): остальные history.actions.* / entity / fields — тоже в PO.
  const text =
    typeof key === 'string' && (key.startsWith('dossier_') || key === 'changed' || key === 'added' || key === 'deleted')
      ? historyPo(key, params)
      : historyPhrase(`actions.${key}`, params)
  return `<span class="text-muted">${text}</span>`
}

export function historySuborderAction(removed, id) {
  const link = `<a href="/orders/${id}">${id}</a>`
  const key = removed ? 'suborderRemoved' : 'suborderAdded'
  return historyAction(key, { link })
}

export function historyFormatBool(value) {
  const yes = value === true || value === 'True' || value === 'true'
  return i18n.global.t(yes ? 'common.yes' : 'common.no')
}

export function historyKnownLabel(text) {
  if (!text || typeof text !== 'string') return text
  const trimmed = text.trim()
  const key = `history.roles.${trimmed}`
  if (i18n.global.te(key)) {
    return i18n.global.t(key)
  }
  return text
}

function currentHistoryLocale() {
  const locale = i18n.global.locale
  if (locale && typeof locale === 'object' && 'value' in locale) {
    return String(locale.value || '')
  }
  return String(locale || '')
}

export function historyFieldLabel(modelName, fieldKey, fallback) {
  const flat = Array.isArray(fieldKey) ? fieldKey.join('.') : String(fieldKey ?? '')
  if (!flat || flat === 'undefined' || flat === 'null') {
    return fallback
  }

  const candidates = [
    `history.fields.${modelName}.${flat}`,
    `history.fields.common.${flat}`,
  ]
  const leaf = flat.includes('.') ? flat.slice(flat.lastIndexOf('.') + 1) : ''
  if (leaf && leaf !== flat) {
    candidates.push(`history.fields.${modelName}.${leaf}`)
    candidates.push(`history.fields.common.${leaf}`)
  }
  // Только текущая раскладка: английский fallback не должен затирать подпись словаря.
  const locale = currentHistoryLocale()
  for (const key of candidates) {
    if (!i18n.global.te(key, locale)) continue
    const val = i18n.global.t(key)
    if (typeof val === 'string' && val && val !== key) {
      return val
    }
    /* nested group object: { _label, name_eng, ... } */
    if (val && typeof val === 'object' && typeof val._label === 'string') {
      return val._label
    }
  }

  /* field_comments.registration_type → «Комментарий: Тип регистрации» */
  if (flat.startsWith('field_comments.')) {
    const inner = flat.slice('field_comments.'.length)
    const innerLabel = historyFieldLabel(modelName, inner, inner)
    if (i18n.global.te('history.phrases.fieldComment')) {
      return i18n.global.t('history.phrases.fieldComment', { field: innerLabel })
    }
    let prefix = 'Field comment'
    if (i18n.global.te(`history.fields.${modelName}.field_comments`)) {
      prefix = i18n.global.t(`history.fields.${modelName}.field_comments`)
    } else if (i18n.global.te('history.fields.common.field_comments')) {
      prefix = i18n.global.t('history.fields.common.field_comments')
    }
    return `${prefix}: ${innerLabel}`
  }

  return fallback
}
